// Kaizen Dashboard components
import SoftBox from "components/SoftBox";

// Kaizen Dashboard examples
import EmpleadoLayout from "components/LayoutContainers/EmpleadoLayout";
import { useParams } from "react-router-dom";
import Header from "./components/Header";
import Body from "./components/Body";
import FooterFactura from "./components/FooterFactura";
import axios from "axios";
import { urlBase } from "services/config";
import { useEffect, useState } from "react";
import SoftButton from "components/SoftButton";

// Data
const printStyles = `
  @media print {
    @page {
      size: A4;
      margin: 10mm;
    }
    
    body * {
      visibility: hidden;
    }
    
    .print-area,
    .print-area * {
      visibility: visible !important;
    }
    
    .print-area {
      position: absolute;
      left: 50% !important;
      top: 10;
      transform: translateX(-50%);
      width: 95% !important;
      max-width: 95% !important;
    }
    
    .no-print {
      display: none !important;
    }
    
    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
  }
`;

function PDF() {
  let { id } = useParams();
  let ultimoCaracterId = id.length - 1;
  let tipo = id[ultimoCaracterId] === "d" ? "DUPLICADO" : "ORIGINAL";
  id = id[ultimoCaracterId] === "d" ? id.slice(0, -1) : id;
  const [factura, setFactura] = useState({});
  const [mostrarBoton, setMostrarBoton] = useState(true);

  const getFactura = async () => {
    try {
      const response = await axios.get(urlBase + `remitoEncabezados/${id}`);
      setFactura(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const imprimirFactura = () => {
    setMostrarBoton(false);
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        setMostrarBoton(true);
      }, 500);
    }, 300);
  };
  useEffect(() => {
    if (id) {
      getFactura();
    }
  }, [id]);

  return (
    <div>
      <style>{printStyles}</style>
      {mostrarBoton && (
        <SoftButton
          onClick={imprimirFactura}
          color="primary"
          sx={{ position: "fixed", right: "30px", bottom: "30px" }}
        >
          IMPRIMIR
        </SoftButton>
      )}
      <SoftBox
        className="print-area"
        mt={1.5}
        sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
      >
        <SoftBox sx={{ maxWidth: "xl", width: "700px" }}>
          <Header factura={factura} tipo={tipo} />
          <Body facturaDetalle={factura.detalles} factura={factura} />
          {/* <FooterFactura factura={factura} saldo={saldo} /> */}
        </SoftBox>
      </SoftBox>
    </div>
  );
}

export default PDF;
